import { useNavigate } from "react-router-dom";
import BackBtn from "../BackBtn/BackBtn";
import { useContext, useState } from "react";
import { AppContext } from "../../context/AppContext";
import Loader from "../Loader/Loader";
import AvatarChatsList from "../AvatarChatsList/AvatarChatsList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faMicrophone, faPaperclip } from "@fortawesome/free-solid-svg-icons";
import ChatMessage from "../ChatMessage/ChatMessage";

export default function AvatarChatContainer() {

    //CONTEXT
    const {  capitalizeWords, userAvatars, darkMode } = useContext( AppContext )

    //STATE
    const [ selectedAvatar, setSelectedAvatar ] = useState( null ) 
    const [ inputValue, setInputValue ] = useState( '' )
    const [ revealList, setRevealList ] = useState( true )
    const [ messages, setMessages ] = useState( [] )
    const [ chatLoader, setChatLoader ] = useState( false )
    const [ counter, setCounter ] = useState( 0 )
    const [ selectedFile, setSelectedFile ] = useState( null ) 

    //ROUTER
    const navigate = useNavigate()

    //FUNCTIONS
    const goBack = () => {
        navigate('/chat')
    }

    const handleSelectedFile = ( file ) => {

        setSelectedFile( file )
    }


    const handleSelectedAvatar = ( avatar ) => {

        if ( avatar ){
            setRevealList( false )
            setSelectedAvatar( avatar )
            setMessages([])
        } else {
            setSelectedAvatar( null )
        }
    }

    const handleChange = ( e ) => {

        const value = e.target.value
        setInputValue( value )

    }

    const handleResponse = ( ) => {

        setChatLoader( true )

        const res1 = `<p>Sure! Im Sal, an entrepreneur driven by innovation, connection, and growth. I'm always on the hunt for fresh ideas and ways to push the boundaries in business. I thrive on creativity and value meaningful relationships that lead to real collaboration. Efficiency is key for me—I'm all about getting the most out of every minute. While I'm deeply committed to my work, I also believe in maintaining a healthy work-life balance and making a lasting impact through what I do.</p>`

        const res2 = `<p>I value:</p>
                <ul>
                    <li><strong>1. Innovation:</strong> Constantly creating and pushing new ideas.</li>
                    <li><strong>2. Connection:</strong> Building deep, meaningful relationships.</li>
                    <li><strong>3. Growth:</strong> Continuous learning and self-improvement.</li>
                    <li><strong>4. Efficiency:</strong> Making the most of my time and resources.</li>
                    <li><strong>5. Work-Life Balance:</strong> Achieving success without sacrificing personal well-being.</li>
                    <li><strong>6. Impact:</strong> Leaving a lasting legacy and making a positive difference.</li>
                </ul>`

        const res3 = `<p>To speak to my values and show how SideHustle delivers on them, here's some targeted messaging:</p>
                <ul>
                    <li><strong>1. Innovation: </strong>Message: “Unlock your creative potential with SideHustle. It's more than a game—it's your go-to tool for sparking groundbreaking ideas and pushing the boundaries of what's possible in business.”</li>
                    <li><strong>2. Connection:</strong> Message: “Forge meaningful connections with fellow entrepreneurs. SideHustle turns networking into a fun, engaging experience where real collaborations happen.”
                
                </li>
                    <li><strong>3. Growth:</strong> Message: “Accelerate your personal and professional growth with SideHustle. Every session is a chance to sharpen your skills, gain new insights, and stay ahead in your entrepreneurial journey.”
                
                </li>
                    <li><strong>4. Efficiency:</strong> Message: “Maximize your time with SideHustle. Streamline your brainstorming and networking into focused, productive sessions that drive real results.”
                
                </li>
                    <li><strong>5. Work-Life Balance:</strong> Message: “Balance business with pleasure. SideHustle offers a refreshing way to develop your business ideas without burning out, combining fun with productivity.”
                
                </li>
                    <li><strong>6. Impact:</strong> Message: “Create a lasting impact with SideHustle. It's not just about immediate wins—it's about building a legacy of innovation and meaningful connections that stand the test of time.”
                </li>
                </ul><p>This messaging directly ties SideHustle to the values that drive me, making it clear how the game aligns with and supports what's most important to me.
                
                </p>
                `
        const res4 = `<p><strong>Top 5 Problems I Face:</strong></p>
                <ul>
                    <li><strong>1. Idea Generation Block (Biggest Problem):</strong> Why: As an entrepreneur, everything starts with a great idea. When I'm stuck, it halts my entire process. Without fresh, viable ideas, it's hard to innovate, grow, or stay competitive in the market.</li>

                    <li><strong>2. Networking Fatigue: </strong>Why: Traditional networking events can be draining and often don't lead to meaningful connections. I need ways to connect with people who truly align with my business goals.

                
                </li>
                    <li><strong>3. Time Management:</strong> Why: With multiple projects on my plate, managing time effectively is crucial. I struggle with finding tools that are both efficient and impactful, without adding to my already packed schedule.
                
                </li>
                    <li><strong>4. Pitching Anxiety: </strong>Why: Even with great ideas, presenting them effectively is a challenge. I sometimes feel unprepared or nervous about pitching, which can lead to missed opportunities.
                
                </li>
                    <li><strong>5. Work-Life Balance:</strong> Why: I'm passionate about my work, but it's easy to let it take over. Maintaining a balance between work and personal life is tough, and I worry about burnout.
                </li>
                </ul><p><strong>Biggest Problem: Idea Generation Block.</strong> This is the biggest because everything else hinges on it. Without new, innovative ideas, the rest of my entrepreneurial efforts—networking, pitching, even balancing my work-life—can fall flat. If I'm not consistently generating fresh ideas, I can't move forward, and my business growth stalls.


                
                </p>
                `

        

        const responses = [
            {
                content: res1,
                sent: false,
                timestamp: Date.now(),
            },
            {
                content: res2,
                sent: false,
                timestamp: Date.now(),
            },
            {
                content: res3,
                sent: false,
                timestamp: Date.now(),
            },
            {
                content: res4,
                sent: false,
                timestamp: Date.now(),
            },

        ]

        const res = responses[counter]

        setTimeout(() => {

            setMessages( ( prevData) => [res, ...prevData ] )

            setChatLoader( false )
        }, 850)

        setCounter( counter !== 3 ? counter + 1 : 0)



    }

    const submitMessage = ( e ) => {

        e.preventDefault()

        
        if ( inputValue !== ''){

            setInputValue( '' )

            const sentMessage = {
                content: inputValue,
                sent: true,
                timestamp: Date.now()
            }
            console.log(sentMessage);
    
            setMessages( ( prevData) => [sentMessage, ...prevData] )

            handleResponse()
        }
    }

    return(
        <div className={`chat main-container ${ !darkMode ? 'light' : ''}`}>
            <BackBtn action={ goBack }/>
            <div className={`chat-sidebar-container`}>
                <div className="avatar-list">
                    { ! userAvatars ?
                        <Loader/>
                        :
                        <> 
                        <AvatarChatsList array={ userAvatars } selectedAvatar={ selectedAvatar } handleSelectedAvatar={ handleSelectedAvatar }/>
                        </>
                    }
                </div>
            </div>
            <span></span>
            <div className={`chat-inner-container ${!revealList ? 'hidden': ''}`}>
                { selectedAvatar ?

                    <>
                        <div className="chat-header-container desktop">
                            <div className="inner">
                                <p>{`Chat with ${capitalizeWords( selectedAvatar.name )}  `}</p>
                            </div>
                        </div>
                        <div className="chat-thread-container">
                            <div className="chat-container">
                                { messages.length > 0 ?
                                    <>
                                    { chatLoader && <span className="chat-loader"></span>}
                                    { messages && 
                                        messages.map(( message, idx) => {
                                            return(
                                                <ChatMessage message={ message } key={ idx }/>
                                            )
                                        })
                                    }
                                    </>
                                    :
                                    <div className="start-chatting-message">
                                        <p>Start chatting with { selectedAvatar.name }</p>
                                    </div>

                                }
                                <>
                                    
                                </>
                            </div>
                        </div>
                        <div className="chat-input-container">
                            <label htmlFor="file-input" style={{ cursor: 'pointer' }} className="attachments">
                                <FontAwesomeIcon icon={ faPaperclip }/>
                            </label>
                            <input type="file"  id="file-input" style={{ display: 'none' }} accept='.txt, .rtf, .doc, .docx, .odt, text/plain, application/msword' onChange={ ( e ) => handleSelectedFile( e.target.files[0] )}/>
                            <form onSubmit={ submitMessage }>
                                <input type="text" onChange={ handleChange } value={ inputValue }/>
                            </form>
                            <button onClick={ submitMessage } className={`submit ${ inputValue !== '' ? 'filled' : '' }`}>
                                <FontAwesomeIcon icon={ faArrowUp }/>
                            </button>
                            <button className="record">
                                <FontAwesomeIcon icon={ faMicrophone }/>
                            </button>
                        </div>
                    </>
                    :
                    <div className="no-data-message">
                        <h3>Start a new chat</h3>
                        <p>Select an avatar to start a conversation</p>
                    </div>
                }

            </div>
        </div>
    )
}